import React from 'react';
import '../cinc/cGlobal';
import '../../inc/genstyle.css';
import logoPS from '../../assets/logo-ps.png';
import CDashboard from './chomepage';
import WarningIcon from '@mui/icons-material/Warning';
import { GoogleLogin } from '@react-oauth/google';


const authKey = global.cconfig.authBearerKey;

class CLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSignedIn: false,
            statLoad: 0
        }
        this.clearSession = this.clearSession.bind(this);
    }
    clearSession() {
        localStorage.removeItem("cuid");
        localStorage.removeItem("cutk");
        localStorage.removeItem("cudocid");
        localStorage.removeItem("cuposition");
        localStorage.removeItem("culevel");
        localStorage.removeItem("cufullname");
        localStorage.removeItem("cuimg");
        localStorage.removeItem("cam");
        window.location.reload();
    }

    onLoginFailed(err) {
        document.getElementById("errormsg").style.display = "block";
        this.setState( prevState => {
            return {  
                ...prevState.isSignedIn, isSignedIn: false,
                ...prevState.statLoad, statLoad: 1
            }
        })
    }
    cekLogin(dataText) {
        var data = JSON.parse(dataText); 
        fetch(global.cconfig.urlLink+"/ceklogin", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res2 => {
            if(res2.status === 200) 
                return res2.json() 
          }).then( resJson => {
            if(resJson.status === '200') {
                
                var uidValue = data.user_email; 
                var utkValue = data.user_id;
                var imgValue = data.user_picture; 

                localStorage.setItem('cuid', uidValue);
                localStorage.setItem('cutk', utkValue);
                localStorage.setItem('cudocid', resJson.values[0].docid);
                localStorage.setItem('cuposition', resJson.values[0].memberPosition);
                localStorage.setItem('culevel', resJson.values[0].userLevel);
                localStorage.setItem('cufullname', resJson.values[0].memberName);
                localStorage.setItem('cuimg', imgValue);
                
                var arrAuth = authKey.split("##");
                var remakeAuthKey = utkValue+"##"+arrAuth[1]+"##"+arrAuth[2];
                fetch(global.cconfig.urlLink+"/amlist/"+resJson.values[0].docid, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': remakeAuthKey,
                    }
                }).then(res2 => {
                    if(res2.status === 200) 
                        return res2.json() 
                }).then( resJson2 => {
                    if(resJson2.status === '200') { 
                        
                        localStorage.setItem('cam', JSON.stringify(resJson2.values.amData));

                        this.setState( prevState => {
                            return {  
                                ...prevState.isSignedIn, isSignedIn: true,
                                ...prevState.statLoad, statLoad: 1
                            }
                        })
                        window.location.href=global.cconfig.urlOrigin+"/chome";
                    } else {
                        console.log('Something happened wrong');
                        this.setState( prevState => {
                            return {  
                                ...prevState.isSignedIn, isSignedIn: false,
                                ...prevState.statLoad, statLoad: 1
                            }
                        })
                        this.clearSession();
                    }
                })
                //------------
            } else {
                console.log('Something happened wrong');
                document.getElementById("errormsg").style.display = "block"; 
                this.setState( prevState => {
                    return {  
                        ...prevState.isSignedIn, isSignedIn: false,
                        ...prevState.statLoad, statLoad: 1
                    }
                })
                this.clearSession();
            }
          }).catch(err => err);
    }
    successLogin = (response) => {
        document.getElementById("errormsg").style.display = 'none';
        var dataSend = response;
        fetch(global.config.urlLink+"/getggprofile", {
            method: 'POST',
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': "*",
                'Authorization': authKey
            },
            body: JSON.stringify(dataSend),
          })
          .then(response => {
            if(response.status === 200) {  return response.json(); } 
            else { console.log('Something happened wrong.'); }
          })
          .then(resJson => {
            var dataTextSend = '{"user_email":"' + resJson.values.email + '","user_id":"' + resJson.values.sub + '","user_fullname":"' + resJson.values.name + '","user_picture":"' + resJson.values.picture + '"}';
            this.cekLogin(dataTextSend);
          });
    
    }
    componentDidMount() {
        document.title = global.cconfig.webtitle;
        document.getElementById("errormsg").style.display = 'none';
    }

    getContent() {
        if (this.state.isSignedIn === true) {
            return <div><CDashboard/></div>
        } else {
              return (
                <div className="main-container center-screen">
                    <div className="login-area divMiddle">
                        <div className="mgT30 divCenter"><img src={logoPS} alt="pointstar" width="150"></img></div>
                        <div className="mgT20 mgB30 divCenter textBold">Sign in with your Company Account</div>
                        <div className="mgT20 mgB20 divCenter"><div className="divhide w70p" id="errormsg"><WarningIcon severity="error" />You are not successfully login.<br/>Please contact administrator for more information</div></div>
                        <div className="mgT30 mgB50 divCenter">
                            <GoogleLogin 
                                type="standard"
                                theme="outline"
                                text="signin"
                                shape="rectangular"
                                onSuccess={this.successLogin}
                                onError={this.onLoginFailed}
                            /> 
                           
                        </div>
                    </div>
                </div>
              )
        }
    }
    
    render() {
        return (
            <div>{this.getContent()}</div>
           
        )
    }
}
export default CLogin;
